/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.5.3(793ede49d53dba79d39e52205f16321278f5183c)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.zh-tw", {
	"vs/base/common/errors": [
		"{0}。錯誤碼: {1}",
		"權限被拒絕 (HTTP {0})",
		"權限被拒絕",
		"{0} (HTTP {1}: {2})",
		"{0} (HTTP {1})",
		"未知的連接錯誤 ({0})",
		"發生未知的連接錯誤。可能是您已經沒有連線到網際網路，或是您連接的伺服器已離線。",
		"{0}: {1}",
		"發生未知的錯誤。如需詳細資訊，請參閱記錄檔。",
		"發生系統錯誤 ({0})",
		"發生未知的錯誤。如需詳細資訊，請參閱記錄檔。",
		"{0} (總計 {1} 個錯誤)",
		"發生未知的錯誤。如需詳細資訊，請參閱記錄檔。",
		"未實作",
		"不合法的狀態: {0}",
		"不合法的引數",
		"不合法的狀態: {0}",
		"不合法的狀態",
		"無法載入需要的檔案。可能是您已經沒有連線到網際網路，或是您連接的伺服器已離線。請重新整理瀏覽器，再試一次。",
		"無法載入必要的檔案。請重新啟動該應用程式，然後再試一次。詳細資料: {0}",
	],
	"vs/base/common/keyCodes": [
		"Windows",
		"Control",
		"Shift",
		"Alt",
		"Command",
		"Windows",
		"Ctrl",
		"Shift",
		"Alt",
		"Command",
		"Windows",
	],
	"vs/base/common/severity": [
		"錯誤",
		"警告",
		"資訊",
	]
});